module.exports = __webpack_public_path__ + "static/media/logo_baclesse.62b39c6e.png";